import { createMyPluginFactory } from 'lib-knowledge-document-structure/plateFunctions';
import { ELEMENT_INLINE_IMAGE } from 'lib-knowledge-document-structure/plateTypes';

import { InlineImageMenu } from './inlineImageMenu';

export const createInlineImagePopupPlugin = createMyPluginFactory({
  key: ELEMENT_INLINE_IMAGE,
  then: () => ({
    renderAfterEditable: InlineImageMenu,
  }),
});
